export const mapCmpObjectData = contentObject => {
  var _properties$hs_variat, _properties$hs_variat2, _properties$hs_name$v, _properties$hs_name, _properties$hs_screen, _properties$hs_screen2, _properties$hs_langua, _properties$hs_langua2;
  const {
    properties
  } = contentObject;
  const variationTypes = ((_properties$hs_variat = (_properties$hs_variat2 = properties.hs_variation) === null || _properties$hs_variat2 === void 0 ? void 0 : _properties$hs_variat2.value) !== null && _properties$hs_variat !== void 0 ? _properties$hs_variat : '').split(';');
  const isLanguageVariant = variationTypes.includes('lang');
  return {
    id: contentObject.objectId,
    name: (_properties$hs_name$v = (_properties$hs_name = properties.hs_name) === null || _properties$hs_name === void 0 ? void 0 : _properties$hs_name.value) !== null && _properties$hs_name$v !== void 0 ? _properties$hs_name$v : '',
    imgSrc: (_properties$hs_screen = (_properties$hs_screen2 = properties.hs_screenshot_preview_url) === null || _properties$hs_screen2 === void 0 ? void 0 : _properties$hs_screen2.value) !== null && _properties$hs_screen !== void 0 ? _properties$hs_screen : '',
    language: isLanguageVariant ? ((_properties$hs_langua = (_properties$hs_langua2 = properties.hs_language) === null || _properties$hs_langua2 === void 0 ? void 0 : _properties$hs_langua2.value) !== null && _properties$hs_langua !== void 0 ? _properties$hs_langua : '').split('-')[0] : ''
  };
};
export const formatAssetOptionText = ({
  name,
  language
}) => language ? `${name} [${language}]` : name;
export const notHasProperty = property => ({
  operator: 'NOT_HAS_PROPERTY',
  property
});
export const propertyNotEquals = (property, value) => ({
  operator: 'NEQ',
  property,
  value
});
export const propertyEquals = (property, value) => ({
  operator: 'EQ',
  property,
  value
});